import Tdg_EventModelBase from '../_generated/modelBases/tdg-event-model-base';

export default class Tdg_EventModel extends Tdg_EventModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
